import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-wait-dialog',
  templateUrl: './wait-dialog.component.html',
  styleUrls: ['./wait-dialog.component.scss']
})
export class WaitDialogComponent implements OnInit {

  dialogWait : any;

  constructor(public dialogRef: MatDialogRef<WaitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.dialogWait = data;
  }

  ngOnInit(): void {

  }

  applyStrings(s: string, replace: string[]) {
    for (let i = 0; i < replace.length; i++) {
      s = s.replace(/%s/, replace[i])
    }
    return s;
  }
}
